import Cookies from 'js-cookie'
import type { GrowniCookiesType } from '../types/Cookies.ts'

// Function which parse cookie string stored in browser cookies
// Examples of use:
// parseCookie(document.cookie)?.__exponea_etc__
// parseCookie(document.cookie)?.growni_uid_token
export const parseCookie = (str: string | undefined): (Record<string, string> & Partial<GrowniCookiesType>) | undefined => {
    if (!str) return undefined

    return str.split(';').reduce<Record<string, string>>((acc, segment) => {
        const [rawKey, ...rawValueParts] = segment.split('=')
        if (!rawKey) return acc

        const key = decodeURIComponent(rawKey.trim())
        const rawValue = rawValueParts.join('=')

        acc[key] = decodeURIComponent(rawValue.trim())
        return acc
    }, {})
}

export function getUserFromCookie(req: any) {
    if (import.meta.server) {
        // On the server, use the request object to get cookies
        const cookie = req.headers.cookie
        if (cookie) {
            const userIdCookie = cookie.split(';').find((c: string) => c.trim().startsWith('__session='))
            return userIdCookie ? userIdCookie.split('=')[1] : null
        }
    } else {
        // On the client, use js-cookie
        return Cookies.get('__session')
    }
}
